import React from 'react'
import { Tabs } from 'antd'
import { patientCareTasksMockData } from './utils/mockdata'
import useTaskFilters from './hooks/useTaskFilters'
import useTaskModals from './hooks/useTaskModals'
import TasksHeader from './Components/TasksHeader'
import TaskFilters from './Components/TaskFilters'
import TaskTable from './Components/TaskTable'
import AddTaskModal from './Components/AddTaskModal'
import CompleteTaskModal from './Components/CompleteTaskModal'

const { TabPane } = Tabs

const PatientCareTasks = () => {
  // Use custom hooks
  const {
    filterValues,
    filteredData,
    pendingTasks,
    completedTasks,
    searchText,
    setSearchText,
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    categoryFilter,
    setCategoryFilter,
    dateRange,
    setDateRange
  } = useTaskFilters(patientCareTasksMockData)

  const {
    isModalVisible,
    isCompleteModalVisible,
    selectedTask,
    form,
    completeForm,
    showModal,
    showCompleteModal,
    handleCancel,
    handleCompleteCancel,
    handleAdd,
    handleComplete
  } = useTaskModals()

  // Combine all filter state for passing to components
  const filterState = {
    searchText,
    setSearchText,
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    categoryFilter,
    setCategoryFilter,
    dateRange,
    setDateRange
  }

  return (
    <div style={{ padding: '24px' }}>
      {/* Header */}
      <TasksHeader onAddTask={showModal} />

      {/* Filters */}
      <TaskFilters filterValues={filterValues} filterState={filterState} />

      {/* Tabs and Tables */}
      <Tabs defaultActiveKey='pending'>
        <TabPane tab={`Pending Tasks (${pendingTasks.length})`} key='pending'>
          <TaskTable data={pendingTasks} isCompleted={false} onCompleteTask={showCompleteModal} />
        </TabPane>
        <TabPane tab={`Completed Tasks (${completedTasks.length})`} key='completed'>
          <TaskTable data={completedTasks} isCompleted={true} />
        </TabPane>
      </Tabs>

      {/* Add Task Modal */}
      <AddTaskModal
        isVisible={isModalVisible}
        onCancel={handleCancel}
        onAdd={handleAdd}
        form={form}
        filterValues={filterValues}
      />

      {/* Complete Task Modal */}
      <CompleteTaskModal
        isVisible={isCompleteModalVisible}
        onCancel={handleCompleteCancel}
        onComplete={handleComplete}
        form={completeForm}
        selectedTask={selectedTask}
      />
    </div>
  )
}

export default PatientCareTasks
